export default function DualCtaSection() {
  return (
    <section className="relative w-full py-16 md:py-24 bg-background-100">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="text-center mb-12 md:mb-16">
          <p className="text-xs md:text-sm text-foreground-500 font-label tracking-wide uppercase mb-3">
            Your Spreadsheet Directory
          </p>
          <h2 className="font-heading text-3xl md:text-5xl lg:text-6xl text-foreground-950 leading-tight">
            Mulebuy <span className="italic font-light">Spreadsheet</span>
            <br />
            Buying Directory
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto mt-4 leading-relaxed">
            Access the complete mulebuy spreadsheet directory with verified product categories, trusted agent links, and updated buying data.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8 max-w-4xl mx-auto">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="group relative rounded-2xl p-8 md:p-10 overflow-hidden cursor-pointer transition-transform hover:scale-[1.02]"
          >
            <div className="absolute inset-0">
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20laptop%20with%20colorful%20spreadsheet%20on%20screen%20displaying%20product%20data%20tables%2C%20surrounded%20by%20small%20fashion%20accessories%20like%20watch%20and%20sunglasses%20on%20a%20light%20oak%20wooden%20desk%2C%20warm%20morning%20sunlight%20from%20window%2C%20cozy%20home%20office%20vibe%2C%20clean%20and%20organized%2C%20editorial%20lifestyle%20photography&width=800&height=600&seq=dual-cta-spreadsheet-01&orientation=landscape"
                alt="Mulebuy spreadsheet directory on laptop"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-primary-500/85"></div>
            </div>
            <div className="relative z-10">
              <div className="absolute top-0 right-0">
                <div className="w-10 h-10 md:w-12 md:h-12 rounded-full bg-white/20 flex items-center justify-center group-hover:bg-white/30 transition-colors">
                  <i className="ri-arrow-right-up-line text-white text-lg md:text-xl group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform"></i>
                </div>
              </div>
              <span className="font-heading text-5xl md:text-7xl font-bold text-white/20">01</span>
              <h3 className="text-xl md:text-2xl font-bold mt-4 text-white whitespace-nowrap">Mulebuy Spreadsheet</h3>
              <p className="text-sm md:text-base text-white/85 mt-3 max-w-xs leading-relaxed">
                Access the complete mulebuy spreadsheet directory. Browse verified products, compare agents, and find the best sourcing options.
              </p>
              <p className="text-sm italic text-white/60 mt-4 whitespace-nowrap">
                Updated weekly with fresh data
              </p>
            </div>
          </a>

          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="group relative rounded-2xl p-8 md:p-10 overflow-hidden cursor-pointer transition-transform hover:scale-[1.02]"
          >
            <div className="absolute inset-0">
              <img
                src="https://readdy.ai/api/search-image?query=Luxury%20fashion%20shopping%20scene%20with%20designer%20handbag%20leather%20wallet%20and%20silk%20scarf%20arranged%20on%20marble%20surface%2C%20soft%20elegant%20color%20palette%20of%20cream%20taupe%20and%20dusty%20rose%2C%20natural%20daylight%20from%20large%20window%2C%20sophisticated%20retail%20aesthetic%2C%20editorial%20product%20photography%20with%20shallow%20depth%20of%20field&width=800&height=600&seq=dual-cta-buynow-02&orientation=landscape"
                alt="Buy fashion products via mulebuy spreadsheet"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-secondary-500/85"></div>
            </div>
            <div className="relative z-10">
              <div className="absolute top-0 right-0">
                <div className="w-10 h-10 md:w-12 md:h-12 rounded-full bg-foreground-900/10 flex items-center justify-center group-hover:bg-foreground-900/20 transition-colors">
                  <i className="ri-arrow-right-up-line text-foreground-900 text-lg md:text-xl group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform"></i>
                </div>
              </div>
              <span className="font-heading text-5xl md:text-7xl font-bold text-foreground-900/10">02</span>
              <h3 className="text-xl md:text-2xl font-bold mt-4 text-foreground-900 whitespace-nowrap">Buy It Now</h3>
              <p className="text-sm md:text-base text-foreground-800 mt-3 max-w-xs leading-relaxed">
                Ready to start? Go directly to the main platform and explore thousands of products with the latest spreadsheet data.
              </p>
              <p className="text-sm italic text-foreground-600 mt-4 whitespace-nowrap">
                Direct access — no signup required
              </p>
            </div>
          </a>
        </div>
      </div>
    </section>
  );
}